<form *ngIf="!isLoading && options && options.length" [formGroup]="organismForm" (submit)="onSubmit()" class="origin-form">
    <mat-form-field class="origin-field">
        <input
            type="text"
            matInput
            formControlName="organism"
            [matAutocomplete]="auto">
        <mat-placeholder class="placeholder">{{'parameters.originSelector.form.origin.shortLabel' | translate}}</mat-placeholder>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option.text.fullLabel}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <button *ngIf="!isLoading" type="submit" mat-raised-button color="accent" [disabled]="organismForm.invalid">
        {{'parameters.originSelector.form.submit.shortLabel' | translate}}
    </button>
</form>
<div *ngIf="isLoading" class="spinner-container">
    <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
</div>
